import request from "../request";

export default {
  //全景转换
  convert(data) {
    return request.post("/convert", data);
  },

  //根据作品获取所有数据
  show(data) {
    return request.get("/show", data);
  },

  //根据作品获取所有数据
  newShow(data) {
    return request.get("/newShow", data);
  },

  //获取场景资料卡
  resume(data) {
    return request.get("/resume", data);
  }
};
